import React from 'react';
import { formatDuration } from '../formatters';
import {
  AVERAGE_COLOR,
  AVERAGE_LABEL,
  COUNT_COLOR,
  COUNT_LABEL,
  TOTAL_COLOR,
  TOTAL_LABEL,
} from './constants';

function TooltipRow({ color, label, value, dashed }) {
  return (
    <div className="time-spent-chart__tooltip-row">
      <span
        className={`time-spent-chart__tooltip-key${dashed ? ' time-spent-chart__tooltip-key--line' : ''}`}
        style={{ backgroundColor: color }}
      />
      <span className="time-spent-chart__tooltip-label">{label}</span>
      <span className="time-spent-chart__tooltip-value">{value}</span>
    </div>
  );
}

// Floating white card: bucket label as title, then every series for that bucket, so
// the reader never has to land on one particular bar to get its number.
export function TimeSpentTooltip({ active, payload }) {
  if (!active || !payload || !payload.length) return null;

  const bucket = payload[0].payload;
  const count = bucket.time_tracked_cards_count || 0;

  return (
    <div className="time-spent-chart__tooltip">
      <div className="time-spent-chart__tooltip-title">{bucket.label}</div>
      <TooltipRow
        color={AVERAGE_COLOR}
        label={AVERAGE_LABEL}
        // No cards tracked means there is no average, which is not the same as zero.
        value={count > 0 ? formatDuration(bucket.average_time_per_card_ms) : '—'}
      />
      <TooltipRow color={TOTAL_COLOR} label={TOTAL_LABEL} value={formatDuration(bucket.time_spent_ms)} />
      <TooltipRow color={COUNT_COLOR} label={COUNT_LABEL} value={count} dashed />
    </div>
  );
}

export default TimeSpentTooltip;
